import { useMemo } from "react"
import { useGetModelNumbersByIds } from "hooks/api/modelNumbers/modelNumbers.hook"
import { flattenCatalogue } from "helpers/modelNumberCatalogue.helper"
import {
	collectCompletedCabinetModelNumberIds,
	findMismatchedFurnitureIds,
} from "components/ui/customWebviewer/shared/ModelNumberMismatchIndicator/modelNumberMismatch.helpers"
import type { TPageElevationData } from "types/elevationReferences.type"

const EMPTY_IDS: ReadonlySet<number> = new Set()

/**
 * REQ-250: completed cabinets whose model number lost its price for their series. The furniture
 * payload carries no prices, so they come from ONE `model_number_ids=` request for the quotation.
 */
export const useModelNumberMismatches = (
	pages: readonly TPageElevationData[] | undefined,
	quotationSeriesId: number | null,
): ReadonlySet<number> => {
	const modelNumberIds = useMemo(() => collectCompletedCabinetModelNumberIds(pages ?? []), [pages])
	const { data } = useGetModelNumbersByIds(modelNumberIds, true, true)

	return useMemo(() => {
		if (!pages || !data) return EMPTY_IDS
		const mismatched = findMismatchedFurnitureIds(pages, quotationSeriesId, flattenCatalogue(data))
		return mismatched.size > 0 ? mismatched : EMPTY_IDS
	}, [pages, data, quotationSeriesId])
}
